import type { StepType } from '@reactour/tour';
import type { TourStepContext } from './types';

/** Bridge 1 — Estruturação */
export const bridge1Steps = (_ctx: TourStepContext): StepType[] => [
  {
    selector: '[data-tour="bridge1-progress"]',
    content:
      'O card de progresso mostra quantos dos quatro artefatos obrigatórios do Bridge 1 já foram criados e aprovados: Caso de Negócio, Termo de Abertura, Stakeholders e Escopo.',
  },
  {
    selector: '[data-tour="bridge1-tab-businesscase"]',
    content:
      'O Caso de Negócio descreve a justificativa estratégica, benefícios esperados e retorno sobre investimento. É o primeiro artefato a ser preenchido.',
  },
  {
    selector: '[data-tour="bridge1-tab-charter"]',
    content:
      'O Termo de Abertura formaliza o projeto: objetivo, sponsor, orçamento inicial e cronograma macro.',
  },
  {
    selector: '[data-tour="bridge1-tab-stakeholders"]',
    content:
      'O mapa de stakeholders identifica todos os envolvidos, seu nível de influência e expectativas em relação ao projeto.',
  },
  {
    selector: '[data-tour="bridge1-tab-scope"]',
    content:
      'A Declaração de Escopo define o que está dentro e fora do projeto, evitando scope creep durante a execução.',
  },
];

/** Bridge 2 e Bridge 3 são placeholders — retornam [] para ocultar o botão ? */

/** Bridge 4 — Encerramento */
export const bridge4Steps = (_ctx: TourStepContext): StepType[] => [
  {
    selector: '[data-tour="bridge4-table"]',
    content:
      'O Bridge 4 lista os projetos elegíveis ao encerramento formal. Selecione um projeto para criar o Termo de Encerramento de Projeto (TEP).',
  },
  {
    selector: '[data-tour="bridge4-wizard"]',
    content:
      'O assistente de encerramento guia você pelos 6 passos: avaliação de prontidão, preenchimento do formulário, revisão, submissão, aprovação e geração do PDF final.',
  },
];
